import { Button, Card, CardContent, Divider, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import Footer from '../../Footer/Footer';

const TeamProject = () => {
    return (
        <Box sx={{ height: 'auto', mt: 5 }}>
            <Link sx={{ position: 'absolute', left: 0, top: 0 }} href="/" underline="none">
                <Button style={{ color: 'rgba(255, 255, 255, 0.689)', padding: '2px 15px', textTransform: 'capitalize', fontSize: '16px', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', }}>
                    Back To Home
                </Button>
            </Link>
            <Typography sx={{ letterSpacing: '1px', fontWeight: 500, }} variant="h6" component="div">
                Career Impacts
            </Typography>
            <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
            <Divider sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }} />

            <Card sx={{ maxWidth: { xs: 500, md: 900 }, position: 'relative', my: 3, mx: 'auto', top: '0px', backgroundColor: '#1976d200', border: { xs: 'none', md: '1px solid #ffffff14', }, boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px', color: 'rgba(255, 255, 255, 0.689)' }}>
                <Box
                    component="div"
                    className='box team-project'
                    sx={{ height: '350px' }}
                />
                <CardContent>

                    <Box>
                        <Typography sx={{ color: '#ffffffeb', letterSpacing: '1px', fontWeight: 500, }} variant="h6" component="div">
                            About Our Website
                        </Typography>
                        <Divider sx={{ width: '100px', p: 0, m: '0px auto 10px auto', border: '1px solid #FFFFFF4E' }} />

                        <Typography sx={{ mb: 3, mx: 4, fontWeight: 300, letterSpacing: '1px', textAlign: 'justify' }} variant="p" component="div">
                            Our website will enable job seekers to publish their resumes and companies can advertise opportunities on this platform, which can be used for professional networking and career advancement.
                        </Typography>

                        <Typography sx={{ color: '#ffffffeb', letterSpacing: '1px', fontWeight: 500, }} variant="h6" component="div">
                            Job Seekers Functionalities
                        </Typography>
                        <Divider sx={{ width: '100px', p: 0, m: '0px auto 10px auto', border: '1px solid #FFFFFF4E' }} />

                        <ul style={{ width: '60%', textAlign: 'justify', margin: '0px auto', lineHeight: '20px' }}>
                            <li>New users can register with email address and password.</li>
                            <li>Registered users can login with email address and password.</li>
                            <li>Users can apply by posting their resume for their desired jobs.</li>
                            <li>Users can see their applications in their dashboards.</li>
                            <li>An user can cancel any of his/her application from dashboard.</li>
                        </ul>

                        <Typography sx={{ mt: 5, color: '#ffffffeb', letterSpacing: '1px', fontWeight: '500' }} variant="h6" component="div">
                            Companies Functionalities
                        </Typography>
                        <Divider sx={{ width: '100px', p: 0, m: '0px auto 10px auto', border: '1px solid #FFFFFF4E' }} />

                        <ul style={{ width: '60%', textAlign: 'justify', margin: '0px auto', lineHeight: '20px' }}>
                            <li>New users can register with email address and password.</li>
                            <li>Registered users can login with email address and password.</li>
                            <li>Companies can post about their job openings and write a description.</li>
                            <li>Companies can update their job posts.</li>
                            <li>Companies can delete their job openings.</li>
                        </ul>
                    </Box>

                    <Typography sx={{ mt: 5, color: '#ffffffeb', letterSpacing: '1px', fontWeight: '500' }} variant="h6" component="div">
                        Technologies
                    </Typography>
                    <Divider sx={{ width: '100px', p: 0, m: '0px auto 10px auto', border: '1px solid #FFFFFF4E' }} />

                    <Box sx={{ mb: 3, px: 5, display: 'flex', justifyContent: 'center', gap: '5px', flexWrap: 'wrap', }}>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">JavaScript</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">ReactJS</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">NodeJS</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">MongoDB</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">ExpressJS</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">React Router</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">Bootstrap</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">CSS</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">Firebase Authentication</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1 }} variant="p" component="div">Heroku</Typography>
                    </Box>


                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Link href="https://career-impacts-fd22e.web.app/" target="_blank" underline="none">
                            <Button style={{ backgroundColor: 'transparent', color: 'rgba(255, 255, 255, 0.689)', border: '1px solid #FFFFFF4E', padding: '5px', width: '80px', textTransform: 'capitalize', }}>Live Site</Button>
                        </Link>
                        <Link sx={{ mx: 2 }} href="https://github.com/AH-Likhon/career-impacts-client-side" target="_blank" underline="none">
                            <Button style={{ width: '130px', textTransform: 'capitalize', backgroundColor: 'transparent', color: 'rgba(255, 255, 255, 0.689)', border: '1px solid #FFFFFF4E', padding: '5px', }}>Client Side Code</Button>
                        </Link>
                        <Link href="https://github.com/AH-Likhon/career-impacts-server-side" target="_blank" underline="none">
                            <Button style={{ width: '130px', textTransform: 'capitalize', backgroundColor: 'transparent', color: 'rgba(255, 255, 255, 0.689)', border: '1px solid #FFFFFF4E', padding: '5px', }}>Sever Side Code</Button>
                        </Link>
                    </Box>
                </CardContent>
            </Card>

            <Footer />
        </Box>
    );
};

export default TeamProject;